var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "learning-path-container" },
    [
      _vm._t("pre-header"),
      _vm._v(" "),
      _c("Header", { attrs: { "learning-path": _vm.learningPath } }),
      _vm._v(" "),
      _vm.isReady
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "swiper",
                  rawName: "v-swiper",
                  value: {
                    freeMode: true,
                    centeredSlides: true,
                    slidesPerView: "auto",
                    spaceBetween: 32,
                    slideToClickedSlide: true,
                    initialSlide: _vm.activeIndex,
                    allowTouchMove: false,
                    keyboard: {
                      enabled: true
                    },
                    mousewheel: {
                      releaseOnEdges: true,
                      forceToAxis: true,
                      invert: true
                    }
                  },
                  expression:
                    "{\n      freeMode: true,\n      centeredSlides: true,\n      slidesPerView: 'auto',\n      spaceBetween: 32,\n      slideToClickedSlide: true,\n      initialSlide: activeIndex,\n      allowTouchMove: false,\n      keyboard: {\n        enabled: true,\n      },\n      mousewheel: {\n        releaseOnEdges: true,\n        forceToAxis: true,\n        invert: true,\n      },\n    }"
                }
              ],
              on: { "slide-change": _vm.updateActiveIndex }
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.learningPath.levels, function(level, index) {
                  return _c(
                    "div",
                    { key: level.number, staticClass: "swiper-slide" },
                    [
                      _c(
                        "div",
                        { staticClass: "slide-contents" },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "level-card",
                                {
                                  active: index === _vm.activeIndex,
                                  tagged:
                                    _vm.isComplete(level) ||
                                    _vm.isPlacedOut(level)
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.openModalOrUpdatePreviousIndex(
                                    level,
                                    index
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "stats" },
                                [
                                  _c("BadgeLabel", {
                                    staticClass: "stat",
                                    attrs: {
                                      text: "Level " + level.number,
                                      color: _vm.badgeColor(level)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isComplete(level)
                                    ? _c("Tag", {
                                        staticClass: "level-tag",
                                        attrs: {
                                          text: "Completed",
                                          color: "#E8F5F2",
                                          "text-color": "#179E7E"
                                        }
                                      })
                                    : _vm.isPlacedOut(level)
                                    ? _c("Tag", {
                                        staticClass: "level-tag",
                                        attrs: {
                                          text: "Placed Out",
                                          color: "#E8F5F2",
                                          "text-color": "#179E7E"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "info" }, [
                                _c("h2", { staticClass: "title" }, [
                                  _vm._v(_vm._s(level.title))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "description" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(level.intro_text) +
                                      "\n              "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "footer" },
                                [
                                  !_vm.isComplete(level)
                                    ? _c("ProgressBar", {
                                        attrs: {
                                          "percent-complete":
                                            level.percent_complete
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          index !== _vm.learningPath.levels.length - 1
                            ? _c("div", { staticClass: "line" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "Button",
                            {
                              staticClass: "cta",
                              attrs: {
                                primary: !_vm.isComplete(_vm.selectedLevel)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openModal(level)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.ctaCopy) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("CoursesModal", {
            attrs: { learningPath: _vm.learningPath, level: _vm.selectedLevel },
            on: {
              close: function($event) {
                _vm.isModalOpen = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }